import React, { useState, useEffect } from 'react';
import { ProductPriceString } from '../utils/ProductPriceString';
import '../../styles/smartbundler.scss';
import CompatioApi from '../../api/CompatioApi';
import EcommerceApi from '../../api/EcommerceApi';
import CompatibleWithHelper from '../utils/CompatibleWithHelper';
import CompatioAnalytics from '../../api/CompatioAnalytics';
import PopupBundler from '../popups/PopupBundler';
import {
  bundlerIconImageUrl,
  maximumCategories,
  maximumProducts,
  eCommercePlatform,
} from '../utils/Constants';

const getCategoryData = async ParentProductSku => {
  const compatioCategoryData = await CompatioApi.getCategoryDataByProductSku(
    ParentProductSku,
    maximumCategories,
    // 5,
    maximumProducts,
    // 150,
    eCommercePlatform
  );
  //By this logic we will get the first available product in the shopify store
  const prodSkus = compatioCategoryData[0].products
    .slice(0, maximumProducts)
    .map(el => {
      return el;
    });

  // console.log(prodSkus, 'compatioCategoryData');
  const selectedProductData = await EcommerceApi.loadProductDataFromEcommerceBundler(
    prodSkus,
    eCommercePlatform,
    [compatioCategoryData[0]]
  );
  // console.log(selectedProductData);

  // console.log(selectedProductData,compatioCategoryData,maximumCategories,maximumProducts,'selectedProductData')
  const productKey = 'compatioScore';
  const sortedProducts = selectedProductData.data.sort((productA, productB) => {
    let result = productA[productKey] > productB[productKey] ? 1 : -1;
    result *= -1;
    return result;
  });
  return sortedProducts;
};

const getTotalPrice = (parentPrice, productPrice, productCurrency) => {
  const parentPriceNum = parentPrice;
  return (
    <span>
      Total Price:{' '}
      <ProductPriceString
        price={parentPriceNum + parseFloat(productPrice)}
        compareAtPrice={0}
        currency={productCurrency !== undefined ? productCurrency : 'USD'}
      />
    </span>
  );
};

const getProductUrl = (singleProduct, parentProduct) => {
  let productLink =
    `${singleProduct.url_product}#${CompatibleWithHelper.keyMap.compatibleWith}=` +
    encodeURIComponent(parentProduct.productName) +
    `&${CompatibleWithHelper.keyMap.sourceMerchantProductVariantID}=` +
    encodeURIComponent(parentProduct.productSku) +
    `&${CompatibleWithHelper.keyMap.sourceCompatioCategoryId}=1` +
    `&${CompatibleWithHelper.keyMap.productPosition}=1` +
    `&${CompatibleWithHelper.keyMap.categoryPosition}=1`;

  return productLink;
};

const handleAddClick = (singleProduct, parentProduct) => {
  // console.log(parentProduct,'singleProduct productId productSku productName')
  CompatioAnalytics.track(
    CompatioAnalytics.events.xrsBundlerClick,
    {
      finalProductID: singleProduct.merchantProductSku,
      parentProductID: singleProduct.parentProductId,
      baseFinalProductID: parentProduct.productSku,
      baseParentProductID: parentProduct.productId,
      baseFinalProductName: parentProduct.productName,
      // product_name: singleProduct.productName,
      clickAction: CompatioAnalytics.clicks.bundlerAddToCart,
    },
    'Bundler',
    'V2'
  );
};

const handleRecShown = (singleProduct, parentProduct) => {
  // console.log(parentProduct,singleProduct,'singleProduct productId productSku productName')
  CompatioAnalytics.track(
    CompatioAnalytics.events.RecShown,
    {
      finalProductID: singleProduct.merchantProductSku,
      parentProductID: singleProduct.parentProductId,
      baseFinalProductID: parentProduct.productSku,
      baseParentProductID: parentProduct.productId,
      baseFinalProductName: parentProduct.productName,
      // product_name: singleProduct.productName,
      // clickAction: CompatioAnalytics.clicks.bundlerAddToCart,
    },
    'Bundler',
    'V3'
  );
};

const SmartBundler = ({ parentProduct }) => {
  const [Loading, SetLoading] = useState(true);
  const [BundlerData, SetBundlerData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [ParentDetails, SetParentDetails] = useState({
    productSku: parentProduct.productSku,
    productName: parentProduct.productName,
    variantTitle: parentProduct.variantTitle,
    price: parentProduct.price,
    productImage: parentProduct.productImage,
    parentProductID: parentProduct.productId,
  });

  const [isReelAdded, SetIsReelAdded] = useState(
    () => parentProduct.productType === 'Reels'
  );
  // const [isReelAdded, SetIsReelAdded] = useState(
  //   () => 'Reels' === 'Reels'
  // );
  const [isOpen, setIsOpen] = useState(false);
  const [ShowOptions, SetShowOptions] = useState(false);

  const toggleBundler = () => {
    SetShowOptions(false);
  };

  const handleChangeVariantId = (variantId, price, name, title, imageUrl) => {
    SetParentDetails({
      productSku: variantId,
      productName: name,
      variantTitle: title,
      price: price,
      productImage: imageUrl !== '' ? imageUrl : parentProduct.productImage,
    });
    // console.log(
    //   variantId,
    //   price,
    //   name,
    //   title,
    //   imageUrl,
    //   'variantId, price, name, title, imageUrl'
    // );
  };

  window.compatioConfig.compatibleProducts.methods.handleChangeVariantId = handleChangeVariantId;

  useEffect(() => {
    const data = getCategoryData(ParentDetails.productSku);
    // console.log(data, 'data');
    data
      .then(response => {
        SetBundlerData(response);
        // console.log(response, 'response');
        // console.log(response[0].productName.toUpperCase().includes('REEL') , response[0].categoryName.toUpperCase().includes('REEL'))
        // console.log(response[0].categoryName)
        // console.log(response[0],'response[0]')
        if (
          response[0].categoryNames.toUpperCase().includes('REEL') &&
          !isReelAdded
        )
          SetIsReelAdded(true);
        setIsError(false);
        SetLoading(false);
      })
      .catch(err => setIsError(true));
  }, [ParentDetails]);

  useEffect(() => {
    if (BundlerData.length > 0) {
      // console.log(BundlerData,'ParentDetails')
      handleRecShown(BundlerData[0], parentProduct);
    }
  }, [BundlerData]);

  if (!Loading && BundlerData.length > 0 && !isError) {
    const productURL = getProductUrl(BundlerData[0], parentProduct);
    // console.log(
    //   BundlerData[0],
    //   parentProduct,
    //   'parentProduct.productId BundlerData[0], parentProduct'
    // );
    return (
      <>
        <div className="xrs-smart-bundler">
          <h3 className="xrs-header">Recommended Bundle</h3>
          <div className="xrs-smart-container">
            <div className="xrs-bundler__image-container xrs-parent-image">
              <img
                src={ParentDetails.productImage}
                // Ensure HTML encoded entities display properly
                alt={ParentDetails.productName}
                //className="xrs-product__image"
                width="100px"
                height="100px"
              />
            </div>
            <div className="xrs-bundler-icon">
              <img
                src={bundlerIconImageUrl}
                width="20px"
                height="20px"
                alt="+"
              />
            </div>
            <div className="xrs-product__image-container xrs-parent-image">
              <a href={productURL}>
                <img
                  src={BundlerData[0].url_image}
                  // Ensure HTML encoded entities display properly
                  alt={BundlerData[0].variantName}
                  //className="xrs-product__image"
                  width="100px"
                  height="100px"
                />
              </a>
            </div>
            <div className="add_both_to_cart-container">
              {getTotalPrice(
                ParentDetails.price,
                BundlerData[0].price,
                parentProduct.currency
              )}
              <button
                id="xrs-smart-bundler"
                className="btn btn--full"
                recommendationsource="Bundler"
                modelversion="V3"
                parentproductid={BundlerData[0].merchantParentProductId}
                bundlerproductid={BundlerData[0].merchantProductSku}
                baseFinalProductName={parentProduct.productName}
                price=""
                baseFinalProductID={parentProduct.productSku}
                baseParentProductID={parentProduct.productId}
                xrsuserid={CompatioAnalytics.getUserId()}
                isreeladded={`${isReelAdded}`}
                onClick={() => {
                  if (isReelAdded) SetShowOptions(true);
                  else SetShowOptions(false);
                  // handleAddClick(BundlerData[0], parentProduct);
                }}
              >
                ADD BOTH TO CART
              </button>

              {/* <a
                onClick={() => {
                  document.getElementsByTagName('BODY')[0].className =
                    'buildAnOutfit template-product data-dc-anchor';
                  window.$('html, body').animate({ scrollTop: 0 }, 'fast');
                  setIsOpen(true);
                }}
              >
                Build an Outfit From These
              </a> */}
            </div>
          </div>
          <div className="xrs-bundler-name-price">
            <p
              className="xrs-product-name-price-block"
              data-testid="productname"
            >
              <span className="xrs-product-name-text">
                <label id="xrs-parent-name">
                  <strong>This Product: </strong>
                  {ParentDetails.variantTitle.includes('Default Title')
                    ? `${ParentDetails.productName}`
                    : `${ParentDetails.productName} - ${ParentDetails.variantTitle}`}
                  &nbsp;
                  <ProductPriceString
                    price={ParentDetails.price}
                    compareAtPrice={0}
                    currency={
                      parentProduct.currency !== undefined
                        ? parentProduct.currency
                        : 'USD'
                    }
                  />
                </label>
              </span>
            </p>
            <p
              className="xrs-product-name-price-block"
              data-testid="productname"
            >
              <span className="xrs-product-name-text">
                <strong>Plus: </strong>
                <a href={productURL}>
                  {BundlerData[0].variantTitle.includes('Default Title')
                    ? `${BundlerData[0].productName}`
                    : `${BundlerData[0].variantName}`}
                </a>
                <ProductPriceString
                  price={BundlerData[0].price}
                  compareAtPrice={BundlerData[0].compareAtPrice}
                  currency={BundlerData[0].currency}
                />
              </span>
            </p>
          </div>
          {ShowOptions ? (
            <PopupBundler
              isOpen={ShowOptions}
              bundlerType="reelsoptions"
              toggleBundler={toggleBundler}
              productData={BundlerData[0]}
              parentProduct={ParentDetails}
              parentProductSku={ParentDetails.productSku}
              parentProductID={ParentDetails.parentProductID}
              bundledProduct={BundlerData[0].merchantProductSku}
              defaultBacking={
                parentProduct.backingData[0] &&
                parentProduct.backingData[0].variantId
              }
            />
          ) : null}
        </div>
        {/* {BundlerData && BundlerData.length >= 1 ? (
          <div className="dc-build-anchor">
            <DCContainer
              isOpen={isOpen}
              props={parentProduct}
              bundledProduct={BundlerData[0]}
              isBlank={false}
              setIsOpen={setIsOpen}
            />
          </div>
        ) : null} */}
      </>
    );
  } else {
    return null;
  }
};

export default SmartBundler;
